(() => {
  const root = document.querySelector('.laser-world');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const form = root.querySelector('.laser-form');
  const budgetField = form?.querySelector('[data-laser-budget-field]') || form?.elements.budget;
  const contextField = form?.querySelector('[data-laser-context-field]') || form?.elements.context;
  const serverStatus = form?.querySelector('[data-laser-server-status]')?.dataset.laserServerStatus;
  const demo = form?.dataset.reviewOnly === 'true';
  const budgetChoices = [...root.querySelectorAll('[data-laser-budget]')];
  const chooseBudget = value => {
    if (!budgetField || ![...budgetField.options].some(option => option.value === value)) return;
    budgetField.value = value;
    budgetChoices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.laserBudget === value)));
    const budgetStatus = root.querySelector('#laser-budget-status');
    if (budgetStatus) budgetStatus.textContent = value ? `Selected for your inquiry: ${value.toLowerCase()}. You can change this below.` : 'Not sure which fits? Tell us about the place and the problem.';
    const oldResult = root.querySelector('#laser-inquiry-result');
    if (demo && oldResult) oldResult.hidden = true;
  };
  budgetChoices.forEach(button => button.addEventListener('click', () => { chooseBudget(button.dataset.laserBudget); form?.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'}); }));
  budgetField?.addEventListener('change', () => chooseBudget(budgetField.value));
  const settingButtons = [...root.querySelectorAll('[data-laser-setting]')];
  const chooseSetting = value => {
    if (!['all','facilities','vineyard'].includes(value)) return;
    settingButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.laserSetting === value)));
    root.querySelectorAll('[data-laser-story]').forEach(story => { story.hidden = value !== 'all' && story.dataset.laserStory !== value; });
  };
  settingButtons.forEach(button => button.addEventListener('click', () => chooseSetting(button.dataset.laserSetting)));
  root.querySelectorAll('[data-laser-context]').forEach(link => link.addEventListener('click', () => { if (contextField) contextField.value = link.dataset.laserContext; }));
  const query = new URLSearchParams(window.location.search);
  const preview = window.Shopify?.theme?.role !== 'main' || Boolean(window.Shopify?.designMode) || query.has('preview_theme_id');
  root.querySelectorAll('[data-laser-preview-note]').forEach(note => { note.hidden = !preview; });
  if (query.get('application')) { chooseSetting(query.get('application')); const initialContext = {facilities:'Commercial property',vineyard:'Vineyard or crop operation'}[query.get('application')]; if (initialContext && contextField && !contextField.value && serverStatus !== 'error') contextField.value = initialContext; }
  const budgetFromQuery = {mid:'Around $5,495',premium:'Around $12,495',compare:'Compare both'}[query.get('budget')];
  if (budgetFromQuery && budgetField && !budgetField.value && serverStatus !== 'error') chooseBudget(budgetFromQuery);
  if (root.dataset.laserDefaultBudget && budgetField && !budgetField.value && serverStatus !== 'error') chooseBudget(root.dataset.laserDefaultBudget);
  if (budgetField) chooseBudget(budgetField.value);
  if (serverStatus === 'success' || serverStatus === 'error') form.querySelector('[data-laser-form-result]')?.focus();
  if (demo) form.addEventListener('input', () => { root.querySelector('#laser-inquiry-result').hidden = true; });
  if (demo) form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const result = root.querySelector('#laser-inquiry-result');
    result.replaceChildren();
    const title = document.createElement('strong');
    title.textContent = 'Preview only — your entries have not been sent.';
    const context = document.createElement('p');
    context.textContent = `${form.elements.context.value} · ${form.elements.budget.value || 'Budget not selected'} · ${form.elements.location.value}`;
    const message = document.createElement('p');
    message.textContent = 'A live enquiry would begin a conversation about your site and equipment needs. This private preview does not save your details, send a message or place an order.';
    result.append(title, context, message);
    result.hidden = false;
    result.focus();
  });
  // Shopify owns cart submission. This only keeps a future multi-variant buybox in sync.
  root.querySelectorAll('[data-laser-purchase-variant]').forEach(select => {
    select.addEventListener('change', () => {
      const choice = select.selectedOptions[0];
      const buybox = select.closest('[data-laser-buybox]');
      if (!choice || !buybox) return;
      const available = choice.dataset.available === 'true';
      buybox.querySelector('.laser-purchase-price').textContent = choice.dataset.price;
      buybox.querySelector('.laser-purchase-model').textContent = choice.dataset.sku;
      buybox.querySelector('.laser-purchase-button').disabled = !available;
      buybox.querySelector('[data-laser-purchase-label]').textContent = available ? 'Add to cart' : 'Currently unavailable';
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', choice.value);
      window.history.replaceState({}, '', variantUrl);
    });
  });
  const equipmentChoices = [...root.querySelectorAll('[data-laser-equipment-source]')];
  equipmentChoices.forEach(button => button.addEventListener('click', () => {
    const figure = root.querySelector('.laser-product-media');
    const image = figure.querySelector('img');
    image.src = button.dataset.laserEquipmentSource;
    image.alt = button.dataset.laserEquipmentAlt;
    figure.querySelector('[data-laser-image]').href = button.dataset.laserEquipmentSource;
    figure.querySelector('figcaption').textContent = button.dataset.laserEquipmentCaption;
    equipmentChoices.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
  }));
  const dialog = root.querySelector('.laser-lightbox');
  if (dialog && typeof dialog.showModal === 'function') {
    root.querySelectorAll('[data-laser-image]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const source = link.querySelector('img');
      const image = dialog.querySelector('img');
      image.src = link.href;
      image.alt = source.alt;
      image.width = source.naturalWidth || Number(source.width);
      image.height = source.naturalHeight || Number(source.height);
      dialog.querySelector('p').textContent = link.closest('figure').querySelector('figcaption').textContent;
      dialog.showModal();
    }));
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  }
})();
